import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { message, Divider } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import moment from 'moment';
import { getRestaurant, getIsSavingRestaurant, getIsSavedRestaurant, getErrorRestaurant } from '../../reducers';
import { setSavedRestaurant, setPromotionsPerDayToRestaurant } from '../../actions/setPromotionsPerDayToRestaurant';
import LoadingPage from '../../components/LoadingPage';
import FormPromotionPerDayResto from '../../components/FormPromotionPerDayResto';
import PromotionsPerDayTable from '../../components/tables/PromotionsPerDayTable';
import cloneDeep from 'lodash.clonedeep';

const days = {
    'monday': 0,
    'tuesday': 1,
    'wednesday': 2,
    'thursday': 3,
    'friday': 4,
    'saturday': 5,
    'sunday': 6
}

function comparePromosPerDay( a, b ) {
    const dayA = a.day;
    const dayB = b.day;
    const dateSinceA = moment(a.dateSince + " " + a.hourSince, 'DD/MM/YYYY HH:mm');
    const dateSinceB = moment(b.dateSince + " " + b.hourSince, 'DD/MM/YYYY HH:mm');
    if ( dayA === dayB ) {
        if ( dateSinceA.isAfter(dateSinceB) ) {
            return 1;
        }
        if ( dateSinceA.isBefore(dateSinceB) ) {
            return -1;
        }
        return 0;
    } else {
        if(days[dayA] < days[dayB]) {
            return -1;
        } else {
            return 1;
        }
    }
};

class PromotionsPerDay extends Component {
    handleDeletePromotion = (record) => {
        const { restaurant, setPromotionsPerDayToRestaurant } = this.props;
        var promosPerDay = {};
        if(restaurant.promotionsPerDay) {
            promosPerDay = cloneDeep(restaurant.promotionsPerDay);
        }
        if(promosPerDay[record.day]) {
            var position = -1;
            promosPerDay[record.day].forEach((promotion, index) => {
                if(promotion.discount === record.discount && promotion.dateSince === record.dateSince && promotion.dateTo === record.dateTo && promotion.hourSince === record.hourSince && promotion.hourTo === record.hourTo) {
                    position = index;
                }
            });
            if (position > -1) {
                promosPerDay[record.day].splice(position, 1);
            }
        }
        Object.keys(promosPerDay).forEach(day => {
            promosPerDay[day].forEach((promotion) => {
                promotion.position = null;
                promotion.day = null;
                promotion.discount = promotion.discount.toString();
            });
        });
        setPromotionsPerDayToRestaurant({ id: restaurant.id, promotionsPerDay: promosPerDay });
    }

    onSubmit = values => {
        this.saveData(values);
    }

    saveData = values => {
        const { restaurant, setPromotionsPerDayToRestaurant } = this.props;
        var promosPerDay = {};
        if(restaurant.promotionsPerDay) {
            promosPerDay = cloneDeep(restaurant.promotionsPerDay);
        }
        if(promosPerDay[values.field_day] !== undefined) {
            promosPerDay[values.field_day].push({
                discount: values.field_discount.toString(),
                dateSince: moment(values.field_date[0]).format('DD/MM/YYYY'),
                dateTo: moment(values.field_date[1]).format('DD/MM/YYYY'),
                hourSince: moment(values.field_hour_from).format("HH:mm"),
                hourTo: moment(values.field_hour_to).format("HH:mm")
            });
        } else {
            promosPerDay[values.field_day] = [{
                discount: values.field_discount.toString(),
                dateSince: moment(values.field_date[0]).format('DD/MM/YYYY'),
                dateTo: moment(values.field_date[1]).format('DD/MM/YYYY'),
                hourSince: moment(values.field_hour_from).format("HH:mm"),
                hourTo: moment(values.field_hour_to).format("HH:mm")
            }]
        }
        setPromotionsPerDayToRestaurant({ id: restaurant.id, promotionsPerDay: promosPerDay });
    }

    getData = () => {
        const { restaurant } = this.props;
        var data = [];
        if(restaurant.promotionsPerDay) {
            const promosPerDay = cloneDeep(restaurant.promotionsPerDay);
            Object.keys(promosPerDay).forEach(day => {
                promosPerDay[day].forEach((promotion, index) => {
                    var promo = promotion;
                    promo.position = day + "-" + index;
                    promo.day = day;
                    data.push(promo);
                });
            });
        }
        data.sort(comparePromosPerDay);
        return data;
    }

    handleResetFields = () => {
        this.setState({ types: {} });
    }

    renderSavedRestaurant = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedRestaurant = false;
        this.props.setSavedRestaurant(isSavedRestaurant);
        return;
    }

    render() {
        const { restaurant, isSavingRestaurant, isSavedRestaurant } = this.props;
        return (
            <div>
                {
                    restaurant ?
                        <div>
                            <Grid>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <PromotionsPerDayTable data={this.getData()} onDeletePromotion={this.handleDeletePromotion}/>
                                    </Col>
                                </Row>
                                <br/>
                                <Divider>Nueva Promoción</Divider>
                                <Row center="xs">
                                    <Col xs={12}>
                                        <FormPromotionPerDayResto onSubmit={this.onSubmit} form={this.props.form} isSaving={isSavingRestaurant} onResetFields={this.handleResetFields} isSavedRestaurant={isSavedRestaurant}/>
                                    </Col>
                                </Row>
                                {
                                    isSavedRestaurant && this.renderSavedRestaurant()
                                }
                            </Grid>
                        </div>
                        :
                        <LoadingPage />
                }
            </div>
        );
    }
}

PromotionsPerDay.propTypes = {
    restaurant: PropTypes.object,
    isSavingRestaurant: PropTypes.bool.isRequired,
    isSavedRestaurant: PropTypes.bool.isRequired,
    errorRestaurant: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setPromotionsPerDayToRestaurant: value => dispatch(setPromotionsPerDayToRestaurant(value)),
    setSavedRestaurant: value => dispatch(setSavedRestaurant(value)),
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
    isSavingRestaurant: getIsSavingRestaurant(state),
    isSavedRestaurant: getIsSavedRestaurant(state),
    errorRestaurant: getErrorRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(PromotionsPerDay));